// extracted by mini-css-extract-plugin
export default {"melodyVideo":"HJ-z","isFullWidth":"IJ-z","landingPageVideo":"JJ-z","play":"KJ-z","iframeVideo":"LJ-z","playHidden":"MJ-z","fullwidth":"NJ-z"};